var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-panel",class:{ shadow: _vm.shadow, overflow: _vm.overflow },style:(_vm.panelStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }